import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, Video } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

// const images = [
//   require('../public/zwoelfk-slider/12k_Summerdrop_1-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Summerdrop_2-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Summerdrop_3-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Summerdrop_4-min.jpg'),
// ];

// const mobileImages = [
//   require('../public/zwoelfk-slider/12k_Slideshow_mobil_1-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Slideshow_mobil_2-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Slideshow_mobil_3-min.jpg'),
//   require('../public/zwoelfk-slider/12k_Slideshow_mobil_4-min.jpg'),
// ];

// const links = [
//   '?categoryId=3003#product-listing',
//   '?categoryId=3003#product-listing',
//   '?categoryId=3003#product-listing',
//   '?categoryId=3003#product-listing',
// ];

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts().then(() => {
      setTimeout(() => {
        requestAnimationFrame(() => {
          onScroll();
        });
      }, 50);
    });

    const frau = document.querySelector('.frau');
    function getElementScrollFraction(elem) {
      return elem.scrollTop / (elem.scrollHeight - elem.clientHeight);
    }

    function isElementInViewport(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0;
    }

    const onScroll = () => {
      if (!frau || getComputedStyle(frau).display === 'none') return;

      const frauHeight = frau.clientHeight;
      const viewHeight = window.innerHeight;

      const maxTopPartOffset = viewHeight - frauHeight;
      const scrollFraction = getElementScrollFraction(document.body.parentElement);
      const minTop = document.querySelector('.main-navigation').offsetHeight;
      const newTop = Math.min(minTop + scrollFraction * maxTopPartOffset, minTop + maxTopPartOffset);

      const footer = document.querySelector('#footer');
      const gretel = document.querySelector('.absolute-logo.mobile-logo');

      if (isElementInViewport(footer)) {
        const gretelRect = gretel.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        gretel.style.position = 'absolute';
        gretel.style.top = window.scrollY + footerRect.top - gretelRect.height + 'px';
        const frauRect = frau.getBoundingClientRect();
        frau.style.top = Math.min(newTop, footerRect.top - frauRect.height - gretelRect.height) + 'px';
      } else {
        frau.style.top = newTop + 'px';
        gretel.style.position = 'fixed';
        gretel.style.top = '';
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [language]);

  return (
    <article>
      <img src={require('./assets/images/fraugretel.svg')} className="img-fluid absolute-logo pc-logo" alt="" />
      <img src={require('./assets/images/frau.svg')} className="pl-2 pb-2 frau mobile-logo" alt="" />
      <img src={require('./assets/images/gretel.svg')} className="pl-2 pb-2 absolute-logo mobile-logo" alt="" />
      <Container fluid className="list-page p-0">
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>
        {/* <h1 className="text-center mb-0 mt-5">{t(`PRODUCTS.TITLE`)}</h1> */}
        <Container className="list-page">
          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
          ) : products.length === 0 ? ( // if no products
            <Alert color="info m-0">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show products
            <Masonry
              id="product-listing"
              className="product-listing p-0"
              products={products.filter((p) => p.tag_ids.includes(10274))}
              filters="off"
              showSubtitle
              showTags
              rowClassName="row no-gutters"
              columnClassName="col"
              //            columnClassName="col-12 col-sm-6 col-md-4 col-xl-3"

              itemProps={{ overlay: true }}
              noResultsClassName="container-fluid my-4 text-info text-center"
            />
          )}
        </Container>
        <div className="text-center mt-3">
          <h4>
            <button className="btn btn-primary btn-lg">
              <a className="text-white" href="/products">
                Alle Artikel →
              </a>
            </button>
          </h4>
        </div>
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(Home);
